import { render, staticRenderFns } from "./PlotWidget.vue?vue&type=template&id=041ffca2&"
import script from "./PlotWidget.vue?vue&type=script&lang=ts&"
export * from "./PlotWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports